import PageHero from '@/components/PageHero';
import TripleSection from '@/components/TripleSection';
import { useModal } from '@/lib/ModalContext';
import s from '@/components/home.module.css';

export default function Attorneys() {
  const { setOpen } = useModal();
  return (
    <>
      <PageHero
        eyebrow="For attorneys"
        title="Practice the law. We'll run the operations."
        sub="AVOWAL connects independent, licensed attorneys with clients who need bounded, limited-scope work — and hands you the operations layer that makes flat-fee representation profitable instead of punishing."
      />

      <TripleSection
        id="why-join"
        label="Why join the network"
        title="You keep your firm. We remove the overhead."
        cards={[
          { num: '/ INDEPENDENCE', title: 'Your firm, your judgment', body: "We don't employ you. You stay independently licensed and personally accountable for the work you sign. AVOWAL routes matched matters; you decide which to accept." },
          { num: '/ LEVERAGE', title: 'ELARIA does the paperwork', body: 'Intake, drafting, citation verification, deadline tracking, and exhibit assembly arrive done. You spend your hours on judgment and advocacy — the work only an attorney can do.' },
          { num: '/ ECONOMICS', title: 'Flat-fee that actually works', body: 'By automating the mechanical layer, limited-scope matters become viable at a flat fee. Predictable scope, predictable pay, no collections drama.' },
        ]}
      />

      <TripleSection
        id="how-engage"
        label="How engagement works"
        title="Matched to your jurisdiction and matter type."
        cards={[
          { num: '/ 01', title: 'We route', body: 'ELARIA triages each intake and routes it to attorneys licensed in the right jurisdiction and qualified for the matter. You see the scope and the flat fee before you accept.' },
          { num: '/ 02', title: 'You confirm', body: 'You review the prepared file, confirm or adjust scope, and sign the limited-scope engagement. The clock starts on the work, not the conversation.' },
          { num: '/ 03', title: 'You decide, ELARIA delivers', body: 'You make every judgment call and sign every filing. ELARIA prepares drafts, verifies citations, and keeps the audit trail. Every output is yours to review before it leaves.' },
        ]}
      />

      <section>
        <div className="container">
          <div className={s.cta}>
            <h2 className={s.ctaTitle}>Apply to the attorney network.</h2>
            <p className={s.ctaSub}>
              We are onboarding a small founding cohort of independent, bar-admitted attorneys for the
              private beta. Tell us your jurisdiction and practice areas — we&rsquo;ll be in touch.
            </p>
            <div className={s.ctaRow}>
              <button className={`${s.btn} ${s.btnPrimary}`} onClick={() => setOpen('waitlist')}>
                Apply (attorneys only)
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
